class BxfDateInputConstants {
    static COMPONENT_NAME = 'bxf-date-input';
    static STRING = {
        BORDER: 'bxf-date-input--content-border',
        NO_BORDER: 'bxf__mouse-focus-no-border',
        COMPACT_THEME: 'bxf-date-input--compact',
        DATE_INPUT_BOX: 'bxf-date-input__input',
        DATE_INPUT_BOX_SMALL: 'bxf-date-input__input--small',
        DATE_INPUT_CONTAINER: 'bxf-date-input__container',
        DATE_INPUT_ERROR: 'bxf-date-input--error',
        DATE_INPUT_WARNING: 'bxf-date-input--warning',
        DATE_INPUT_FOCUSED: 'bxf-date-input--focused',
        DATE_INPUT_KEY_FOCUSED: 'bxf-date-input--focused-keyboard',
        DATE_INPUT_LABEL_WRAPPER_LEFT: 'bxf-date-input-wrapper__label--left',
        DATE_INPUT_LABEL_WRAPPER_LEFT_COMPACT: 'bxf-date-input-wrapper__label--left-compact',
        DATE_INPUT_LABEL_WRAPPER: 'bxf-date-input-wrapper__label',
        BOX_CONTAINER: 'box-container',
        LABEL_CONTAINER: 'label-container',
        DATE_INPUT_LABEL: 'bxf-date-input__label',
        DATE_INPUT_LABEL_COMPACT: 'bxf-date-input__label--compact',
        DATE_INPUT_LABEL_WITH_INSTRUCTIONAL_TEXT: 'bxf-date-input__label--instructional-text',
        DATE_INPUT_POPULATED_COLOR: 'bxf-date-input__input--populated-color',
        DATE_INPUT_REQUIRED: 'bxf-date-input__label--required',
        DATE_INPUT_START: 'bxf-date-input--start',
        DATE_INPUT_END: 'bxf-date-input--end',
        INPUT_START: 'bxf-date-input__box--start',
        INPUT_END: 'bxf-date-input__box--end',
        DISABLED_INPUT: 'bxf-date-input--disabled',
        READONLY_INPUT: 'bxf-date-input--readonly',
        DISABLED_LABEL: 'bxf-date-input__label--disabled',
        DOCUMENT: 'document',
        ERROR_MESSAGE: 'bxf-date-input__message--error',
        WARNING_MESSAGE: 'bxf-date-input__message--warning',
        FIT_CONTENT: 'bxf-date-input__fit-content',
        FIT_CONTENT_RIGHT: 'bxf-date-input__fit-content--right',
        HOST: 'host',
        LABEL_COMPACT_THEME: 'bxf-date-input-wrapper__label--compact',
        LABEL_LARGE_THEME: 'bxf-date-input-wrapper__label--large',
        LARGE: 'large',
        LEFT_LABEL: 'bxf-date-input__label-left',
        LEFT_LABEL_CONTAINER: 'bxf-date-input-label-container',
        LEFT_LABEL_COMPACT: 'bxf-date-input__label-left--is-compact',
        LEFT: 'left',
        REGULAR: 'regular',
        SMALL: 'small',
        INVALID_DATE_LABEL: 'Invalid Date',
        DATE_INPUT_MASK: 'bxf-date-input__mask',
        DATE_INPUT_MASK_SMALL: 'bxf-date-input__mask--small',
        SMALL_HEIGHT: 'bxf-date-input__size--small',
        REGULAR_HEIGHT: 'bxf-date-input__size--regular',
        LARGE_HEIGHT: 'bxf-date-input__size--large',
        SMALL_HEIGHT_NO_BORDER: 'bxf-date-input__size--small-no-border',
        REGULAR_HEIGHT_NO_BORDER: 'bxf-date-input__size--regular-no-border',
        LARGE_HEIGHT_NO_BORDER: 'bxf-date-input__size--large-no-border',
        INSTRUCTIONAL_TEXT: 'bxf-date-input__instructional-text',
        MMM: 'MMM',
        MMMM: 'MMMM',
        CONTAINER_PADDING_OFFSET: 50,
        MAX_FULL_MONTH_DATE_LENGTH: 17,
        SMALL_FONT_SIZE: 14,
        DEFAULT_FONT_SIZE: 16,
        TODAY_RELATIVE: 'T',
        DEFAULT_RELATIVE_DATE: 'T-1',
        SPACE: ' ',
        ERROR_ICON_SPACING: 'bxf-date-input--error-icon',
    };
}

class BxfDatePickerConstants {
    static STRING = {
        BXF_DATE_PICKER: 'bxf-date-picker',
        BXF_CALENDAR: 'bxf-calendar',
        BXF_ICON: 'bxf-icon',
        CONTAINER: 'bxf-date-picker__input',
        DISABLED_LABEL: 'bxf-date-input__label--disabled',
        FOCUS_BOTTOM_BORDER: 'bxf-date-picker--container-focus-bottom',
        DISABLED_CONTAINER: 'bxf-date-picker--container-disabled',
        DATE_INPUT: 'bxf-date-picker__date-input',
        CALENDAR_BUTTON_LABEL: 'Calendar Button',
        SUFFIX_BUTTON: 'suffix-button',
        MARGIN_RIGHT: 'bxf-date-picker__start-date-picker--margin-right',
        DEFAULT_US: 'Default, US',
        CALENDAR: 'bxf-date-picker__calendar',
        CALENDAR_BUTTON: 'bxf-date-picker__calendar_button',
        LABEL_CONTAINER: 'label-container',
        LABEL: 'bxf-date-picker__label',
        LABEL_COMPACT: 'bxf-date-picker__label--compact',
        CALENDAR_BUTTON_CONTAINER: 'bxf-date-picker__calendar_button--container',
        LEFT_LABEL_CONTAINER: 'bxf-date-picker__left-label-container',
        DATE_PICKER_CONTAINER: 'bxf-date-picker__container',
        DATE_PICKER_INPUT: 'bxf-date-picker__input',
        PICKER_INPUT_FOCUS: 'bxf-date-picker__input--focus',
        DATE_PICKER_KEY_FOCUSED: 'bxf-date-picker--focused-keyboard',
        LEFT_LABEL: 'bxf-date-picker__label-left',
        LEFT_LABEL_COMPACT: 'bxf-date-picker__label-left--compact',
        INVALID_CONTAINER: 'bxf-date-picker--container-invalid',
        WARNING_CONTAINER: 'bxf-date-picker--container-warning',
        SUCCESS_CONTAINER: 'bxf-date-picker--container-success',
        FOCUSED_CONTAINER: 'bxf-date-picker--container-focused',
        ERROR_MESSAGE: 'bxf-date-picker__message--error',
        WARNING_MESSAGE: 'bxf-date-picker__message--warning',
        SUCCESS_MESSAGE: 'bxf-date-picker__message--success',
        CALENDAR_ICON: 'calendar',
        CALENDAR_LABEL: 'Open Calendar',
        SOURCE_ELEMENT: 'sourceElement',
        TARGET_ELEMENT: 'targetElement',
        VISIBLE: 'visible',
        AUTO: 'auto',
        PATH: 'path',
        CLICK: 'click',
        MOUSE_DOWN: 'mousedown',
        DATE_INPUT_REQUIRED: 'bxf-date-picker__label--required',
        MOUSEOVER: 'mouseover',
        MOUSEOUT: 'mouseout',
        RESIZE: 'resize',
        SCROLL: 'scroll',
        BLUR_CHANGED: 'blurChanged',
        DETAIL_RELATED_TARGET: 'detail.relatedTarget',
        ARTICLE_INPUT_MASK: 'article.bxf-input-mask',
        DATE_IS_REQUIRED: 'Date is required',
        KEEP_RELATIVE_DATE: 'T-N',
        SUFFIX_INERT: 'suffix-inert',
        DEFAULT_RELATIVE_DATE: 'T-1',
        RELATIVE_DATE_REGEX: /^[tT][-+]/,
        SPECIFIC_DATE_REGEX: /(?:\w+\W){2}\w+/,
        FULL_YEAR: 'YYYY',
        TODAY_RELATIVE: 'T',
    };
}

export { BxfDateInputConstants as B, BxfDatePickerConstants as a };
